import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Vehicle } from 'src/app/demo/models/common-data-types';

@Component({
    selector: 'app-insured-vehicle-card',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './insured-vehicle-card.component.html',
    styleUrl: './insured-vehicle-card.component.scss',
})
export class InsuredVehicleCardComponent {
    @Input() vehicle!: Vehicle;
}
